import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box, Flex, Skeleton } from "@chakra-ui/react";
import { MdOutlineDragIndicator, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { LuReplace } from "react-icons/lu";
import { TbViewportWide, TbViewportNarrow } from "react-icons/tb";

export const SortableOverviewPageTiles = ({ id, children, tileIsDisplayed, toggleTileDisplay, isEmbeddedCode, isEmptyState,
  showReplaceButton,
  handleReplaceCode,
  setShowRemoveVideoModal,
  toggleFullWidthTile, isFullWidthTile, isMobileView }) => {

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: id });


  const sortableStyle = {
    transform: CSS.Translate.toString(transform),
    // transform: CSS.Transform.toString(transform),
    transition,
    // background: isDragging ? 'white' : 'none',
    zIndex: isDragging ? "100" : "auto",
    // opacity: isDragging ? 0.3 : 1,
    ...(!!isFullWidthTile && { gridColumn: !isMobileView && "span 2" })
  };

  if (!!isEmbeddedCode) {

    const isCodeEmbedTile = (id === "iframe-embed-tile") ? true : false
    return (
      <Box className={"tile-container-loom-video"} bg='white' ref={setNodeRef} style={sortableStyle}>
        <Flex w='100%' gap={2} bg='white' color='black' justify='flex-end' align='center' p='1em 0.5em 0 0.5em'>
          {showReplaceButton && <Box as={LuReplace} color={'gray.500'} boxSize="1em" py='0.1em' cursor='pointer'
            onClick={() => isCodeEmbedTile ?
              handleReplaceCode()
              : setShowRemoveVideoModal(true)} />}

          {(!showReplaceButton) ?
            <Flex justify='flex-between' align='center'>
              <Box mr='0.5em' fontSize='0.6em' color='gray.500'>No content • Tile hidden</Box>
              <Box as={MdVisibilityOff} color={'gray.500'} boxSize="1em" py='0.1em' cursor={"default"} />
            </Flex>
            :
            <Flex justify='flex-between' align='center'>
              <Box mr='0.5em' fontSize='0.6em' color='gray.500' display={tileIsDisplayed ? "none" : "block"}>Tile hidden</Box>
              <Box as={tileIsDisplayed ? MdVisibility : MdVisibilityOff} color={'gray.500'} boxSize="1em" py='0.1em' cursor={"pointer"} onClick={() => toggleTileDisplay(id, !tileIsDisplayed)} />
            </Flex>
          }
          <Box as={isFullWidthTile ? TbViewportNarrow : TbViewportWide} color={'gray.500'} boxSize="0.9em" py='0.1em' cursor='pointer' onClick={() => toggleFullWidthTile(id, !isFullWidthTile)} />
          <Box as={MdOutlineDragIndicator} {...listeners} {...attributes} color={'gray.500'} boxSize="1em" py='0.1em' cursor='grab' />

        </Flex>

        {/* {children} */}
        {isDragging ?
          <Flex h='100%' key={id} border='2px solid' borderColor='brand.500' rounded='0.25em'>
            <Skeleton w='100%' key={id} fitContent={true} startColor='white' endColor="white">{children}</Skeleton>
          </Flex>
          : children}
      </Box>
    );
  }

  return (
    <Box ref={setNodeRef} style={sortableStyle} position='relative'>
      <Flex gap={2} position='absolute' top='1em' right='1em' bg='white' align='center' visibility={isDragging && 'hidden'}>
        <Flex justify='flex-between' align='center' gap={2}>
          {isEmptyState ?
            <Box fontSize='0.6em' color='gray.500'>
              No content • Hidden
            </Box>
            : tileIsDisplayed &&
            <Box color='gray.500' fontSize='0.6em' visibility={tileIsDisplayed ? "hidden" : "block"}>
              Tile hidden
            </Box>
          }
          <Box as={tileIsDisplayed ? MdVisibility : MdVisibilityOff} color={'gray.500'} boxSize="1em" py='0.1em' cursor='pointer' onClick={() => toggleTileDisplay(id, !tileIsDisplayed)} />
        </Flex>
        <Box as={isFullWidthTile ? TbViewportNarrow : TbViewportWide} color={'gray.500'} boxSize="0.9em" py='0.1em' cursor='pointer' onClick={() => toggleFullWidthTile(id, !isFullWidthTile)} />
        <Box as={MdOutlineDragIndicator} {...listeners} {...attributes} color={'gray.500'} visibility={isDragging && 'hidden'} boxSize="1em" py='0.1em' cursor='grab' />
      </Flex>

      {isDragging ?
        <Flex h='100%' key={id} border='2px solid' borderColor='brand.500' rounded='0.25em'>
          <Skeleton w='100%' key={id} fitContent={true} startColor='white' endColor="gray.100">{children}</Skeleton>
        </Flex>
        : children}

    </Box>
  );
};